export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13104.c0dddc13.jpg";